import { render, staticRenderFns } from "./formInfo.vue?vue&type=template&id=4a5096ed&scoped=true&"
import script from "./formInfo.vue?vue&type=script&lang=js&"
export * from "./formInfo.vue?vue&type=script&lang=js&"
import style0 from "./formInfo.vue?vue&type=style&index=0&id=4a5096ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5096ed",
  null
  
)

export default component.exports